/* eslint-disable max-len */
import React from 'react';

const SelectedIcon = props => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="8.5" cy="8.5" r="5.5" fill="#FFF" />
      <path
        fill="#0060FF"
        fillRule="nonzero"
        d="M8 0C3.564 0 0 3.564 0 8s3.564 8 8 8 8-3.564 8-8-3.564-8-8-8zm4.618 5.49L6.8 11.528a.33.33 0 0 1-.255.11c-.109 0-.218-.037-.254-.11L3.455 8.473 3.382 8.4a.393.393 0 0 1-.11-.255c0-.072.037-.181.11-.254l.509-.51a.352.352 0 0 1 .509 0l.036.037 2 2.146a.176.176 0 0 0 .255 0l4.873-5.055h.036a.352.352 0 0 1 .51 0l.508.51c.146.108.146.326 0 .472z"
      />
    </g>
  </svg>
);

export default SelectedIcon;
/* eslint-enable max-len */
